module.exports = __webpack_public_path__ + "img/edge3.2e8e49ca.jpg";